import React, { useEffect, useState } from "react";
import axios from "axios";
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import SearchIcon from '@mui/icons-material/Search';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import { useCookies } from 'react-cookie';

import Swal from 'sweetalert2';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function ModalProyectosLista(params) {
    axios.defaults.withCredentials = true;

    const [cookies, setCookie] = useCookies(["proyecto"]);

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };


    const [proyectos, setProyectos] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {

        const fetchProyectos = async () => {
            try {
                // Realiza la llamada POST
                const response = await axios.post(
                    "https://apimedidas.ahouseinterior.com/lista_proyectos.php",
                    { datos: "proyectos" }, // Cuerpo de la solicitud
                    { headers: { "Content-Type": "application/json" } } // Asegura que el tipo de contenido sea JSON
                );

                // Verifica y almacena los datos recibidos
                if (response.data && response.data.status === "success") {                    
                    setProyectos(response.data.pro); // Ajusta el campo según tu estructura
                } else {
                    setError("No se pudo obtener el último proyecto.");
                }
            } catch (err) {
                setError("Ocurrió un error al conectar con el servidor.");
            } finally {
                setLoading(false);
            }
        };

        if (proyectos == null && open) {
            fetchProyectos();
        }
    }, [open]);


    const handleSelectProyect = (id) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Vas a cargar un nuevo proyecto.",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Abrir',
        }).then((result) => {
            if (result.isConfirmed) {
                // El usuario hizo clic en "Sí"
                params.handleChargeProyect(id, "Proyecto Cargado")
                handleClose();
                setCookie("proyecto", id, {
                    path: "/",
                    maxAge: 99000000
                })

            } else {
                // El usuario hizo clic en "No"
                Swal.fire({
                    title: 'Accion Cancelada',
                    icon: 'error',
                    text: "",
                    showConfirmButton: false,
                    timer: 1000

                });
            }
        });

    }


    return (
        <React.Fragment>
            <IconButton color="white2" size="large" onClick={handleClickOpen}>
                <SearchIcon style={{ fontSize: '30px' }} />
            </IconButton>
            <BootstrapDialog
                fullScreen
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                disableRestoreFocus
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Proyectos
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    {loading && <p>Cargando...</p>}
                    {error && <p style={{ color: "red" }}>{error}</p>}
                    {proyectos && (
                        <Grid container spacing={2} rowSpacing={2} columns={10}>

                            {proyectos.slice().reverse().map((proyecto, index) => (
                                <Grid size={10} key={index}>
                                    <Paper style={{ padding: "20px" }}>
                                        <Grid container spacing={2} rowSpacing={2} columns={10}>
                                            <Grid size={8}>
                                                <Typography variant='h6' color={(params.id_proyecto == proyecto.id) ? "success" : "primary"}>{proyecto.id} - {proyecto.nombre}</Typography>
                                                <Typography variant='p'>{proyecto.ubicacion}</Typography>
                                            </Grid>
                                            {(params.id_proyecto !== proyecto.id) &&
                                                <Grid size={2}>
                                                    <IconButton color="primary" size="large" onClick={() => handleSelectProyect(proyecto.id)}>
                                                        <ThumbUpAltIcon style={{ fontSize: '30px' }} />
                                                    </IconButton>
                                                </Grid>
                                            }
                                        </Grid>
                                    </Paper>
                                </Grid>
                            ))}
                        </Grid>
                    )}
                </DialogContent>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default ModalProyectosLista